import Dashboard from "./primaryDashboard/Dashboard";

export default Dashboard;
